import { render, staticRenderFns } from "./RelativeBase.vue?vue&type=template&id=49eb8e34&"
import script from "./RelativeBase.vue?vue&type=script&lang=ts&"
export * from "./RelativeBase.vue?vue&type=script&lang=ts&"
import style0 from "./RelativeBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports